@if (vm$ | async; as vm) {
<div class="user">
  <div class="user-avatar">
    {{ getInitials(vm.userData.firstName, vm.userData.lastName) }}
  </div>
  <div class="user-grouping">
    <p class="user-name"> {{vm.userData.firstName}} {{vm.userData.lastName}}</p>
    <p class="user-title">Support</p>
  </div>
</div>
}